<template>
  <v-layout row wrap class="pt-2">
    <v-flex xs4>
      <v-card>
        <v-card-title style="background:#F4F7FC;letter-spacing: .5px;;color: #1A2453;font-size: 12px;" class="py-2 subheading text-uppercase">
          <b>Columns</b>
          <v-spacer />
          <v-icon @click="addColumn" small class="white--text">fas fa-plus-circle</v-icon>
        </v-card-title>
        <v-card-text style="height:425px;overflow-y:auto" class="pa-0 ma-0">
          <template v-for="(col, objKey) in value">
            <v-layout row wrap class="pa-0 ma-0">
              <v-flex xs9>
                <v-checkbox
                  v-model="col.visible"
                  :label="col.label"
                  color="blue"
                  single-line
                  class="pa-0 ma-0"
                  height="30px"
                  hide-details
                  @change="submit(objKey)"
                  style="margin:0px;padding:0px"
                ></v-checkbox>
              </v-flex>
              <v-flex xs3 class="text-xs-right pt-1">
                <v-icon
                  @click="setSelectedColumn(col)"
                  v-if="col.visible"
                  small
                  class="grey--text"
                >fas fa-edit</v-icon>
              </v-flex>
            </v-layout>
            <v-divider class="blue lighten-3" />
          </template>
        </v-card-text>
      </v-card>
    </v-flex>
    <v-flex xs8 pl-3 v-if="!selectedColumn.label">
      <v-card style="min-height:450px">
        <v-card-title style="background:#F4F7FC;letter-spacing: .5px;;color: #1A2453;font-size: 12px;" class="py-2 subheading text-uppercase">
          <strong>Layout & Sort</strong>
        </v-card-title>
        <v-card-text
          v-if="!selectedColumn.label"
          style="height:425px;overflow-y:auto"
          class="pa-0 ma-0"
        >
          <template v-for="layout in columnLayout">
            <v-chip
              close
              @input="removeColumnFromLayout(layout)"
              small
              outline
              class="indigo--text"
            >{{(value[layout] && value[layout].label) || ''}}</v-chip>
          </template>
        </v-card-text>
      </v-card>
    </v-flex>
    <v-flex xs8 pl-3 v-if="selectedColumn.label">
      <v-card>
        <v-card-title v-if="selectedColumn.label"style="background:#F4F7FC;letter-spacing: .5px;;color: #1A2453;font-size: 12px;" class="py-2 subheading text-uppercase">
          <strong>{{selectedColumn.label}}</strong>
          <v-spacer />
          <v-icon @click="saveNewColumn" small class="blue--text">fas fa-save</v-icon>&nbsp; &nbsp;
          <v-icon @click="clearSelected" small class="blue--text">fas fa-times</v-icon>
        </v-card-title>
        <v-card-text v-if="selectedColumn.label">
          <v-layout row wrap class="text-xs-left">
            <v-flex xs3 pr-1>
              <b>Column Name</b><br/>
              <v-text-field
                class="style-input pt-1"
                type="text"
                @change="submit3"
                v-model="selectedColumn.key"
                required
                outline
              />
            </v-flex>
            <v-flex xs3 pr-1>
              <b>Label</b><br/>
              <v-text-field
                class="style-input pt-1"
                type="text"
                @change="submit3"
                v-model="selectedColumn.label"
                required
                outline
              />
            </v-flex>
            <v-flex xs3 pr-1>
              <b>Data Type</b><br/>
              <v-select
                class="style-input pt-1"
                item-text="name"
                item-value="id"
                height="20px"
                @change="submit3"
                v-model="selectedColumn.dataType"
                :items="dataTypes"
                outline
              ></v-select>
            </v-flex>
            <v-flex xs3 pr-1>
              <b>Format</b><br/>
              <v-text-field
                class="style-input pt-1"
                type="text"
                @change="submit3"
                v-model="selectedColumn.format"
                required
                outline
              />
            </v-flex>
            <v-flex xs2 pr-1>
              <b>Width</b><br/>
              <v-text-field
                class="style-input pt-1"
                type="text"
                @change="submit3"
                v-model="selectedColumn.width"
                required
                outline
              />
            </v-flex>
            <v-flex xs2 pr-1>
              <b>Height</b><br/>
              <v-text-field
                class="style-input pt-1"
                type="text"
                @change="submit3"
                :readonly="selectedColumn.dataType=='image'"
                v-model="selectedColumn.height"
                required
                outline
              />
            </v-flex>
            <v-flex xs2 pr-1>
              <b>Font</b><br/>
              <v-autocomplete
                :items="fontList"
                class="style-input pt-1"
                hide-details
                @change="submit3"
                v-model="selectedColumn.font"
                outline
              ></v-autocomplete>
            </v-flex>
            <v-flex xs2>
              <b>Size</b><br/>
              <v-autocomplete
                :items="fontSize"
                class="style-input pt-1"
                hide-details
                @change="submit3"
                v-model="selectedColumn.fontSize"
                outline
              />
            </v-flex>
            <!-- <v-flex xs1 class="pa-3 pl-0 pr-0 text-xs-center">
              <verte
                :rgbSliders="true"
                @change="submit3"
                model="hex"
                v-model="selectedColumn.color"
                picker="wheel"
              ></verte>
            </v-flex> -->
            <v-flex xs6 class="pa-1">
              <verte
                :rgbSliders="true"
                @change="submit3"
                model="hex"
                v-model="selectedColumn.color"
                picker="wheel" class="pt-1"
                style="float:left; zoom:90%"
              ></verte>
              <v-btn-toggle
                @change="submit3"
                v-model="selectedColumn.bold"
                class="transparent white--text"
              >
                <v-btn icon @click="submit3" small class="black--text" flat>
                  <v-icon>format_bold</v-icon>
                </v-btn>
              </v-btn-toggle>
              <v-btn-toggle
                @change="submit3"
                v-model="selectedColumn.italic"
                class="transparent white--text"
              >
                <v-btn icon @click="submit3" small class="black--text" flat>
                  <v-icon>format_italic</v-icon>
                </v-btn>
              </v-btn-toggle>
              <v-btn-toggle
                @change="submit3"
                v-model="selectedColumn.align"
                class="transparent white--text"
              >
                <v-btn @click="submit3" value="left" flat class="black--text">
                  <v-icon>format_align_left</v-icon>
                </v-btn>
                <v-btn @click="submit3" value="center" flat class="blac--text">
                  <v-icon>format_align_center</v-icon>
                </v-btn>
                <v-btn @click="submit3" value="right" flat class="black--text">
                  <v-icon>format_align_right</v-icon>
                </v-btn>
              </v-btn-toggle>
            </v-flex>
            <v-flex xs11>
              <v-textarea
                class="style-input mr-2"
                label="Expression"
                type="text"
                @change="submit3"
                v-model="selectedColumn.expression"
                required
                outline
              />
            </v-flex>
            <v-flex xs1 pl-3>
              <v-icon @click="showExpressionDialog" small>fas fa-edit</v-icon>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
      <v-dialog v-model="expressionDialog" max-width="850px">
        <ExpressionBuilder
          v-if="expressionDialog"
          :columns="value"
          v-on:applyExpression="applyExpression"
        />
      </v-dialog>
    </v-flex>
  </v-layout>
</template>
<script>
import Verte from "verte";
import "verte/dist/verte.css";
import ExpressionBuilder from "@/components/ExpressionBuilder.vue";
import lodash from "lodash";

export default {
  components: { Verte, ExpressionBuilder },
  props: ["value", "layout"],
  data() {
    return {
      columnLayout: [],
      selectedColumn: {},
      newColumn: false,
      expressionDialog: false,
      dataTypes: [
        { id: "date", name: "Date" },
        { id: "time", name: "Time" },
        { id: "number", name: "Decimal" },
        { id: "currency", name: "Currency" },
        { id: "image", name: "Image" },
        { id: "integer", name: "Number" },
        { id: "expression", name: "Expression" },
        { id: "varible", name: "Variable" },
        { id: "string", name: "Text" }
      ],
      fontList: [
        { text: "Arial" },
        { text: "Calibri" },
        { text: "Courier" },
        { text: "Verdana" }
      ],
      fontSize: [
        { text: "100%" },
        { text: "75%" },
        { text: "50%" },
        { text: "25%" },
        { text: "0%" }
      ]
    };
  },
  created: function() {
    this.columnLayout = this.layout
  },
  watch: {
    layout() {
      this.columnLayout = this.layout;
    }
  },
  methods: {
    applyExpression($expr) {
      this.selectedColumn.expression = $expr;
      this.expressionDialog = false;
    },
    clearSelected() {
      this.selectedColumn = {};
    },
    removeColumnFromLayout($column) {
      this.columnLayout.splice(this.columnLayout.indexOf($column), 1);
      this.value[$column].visible = false;
    },
    saveNewColumn() {
      this.value[this.selectedColumn.key] = Object.assign(
        {},
        this.selectedColumn
      );
      this.newColumn = false;
      this.$forceUpdate();
    },
    addColumn() {
      this.newColumn = true;
      this.selectedColumn = {
        key: "",
        dataType: "",
        width: 0,
        height: 0,
        visible: "",
        sort_order: 0,
        type: "",
        label: "<NewColumn>",
        fontSize: "",
        bold: false,
        italic: true,
        align: "left"
      };
    },
    submit3() {},
    setSelectedColumn($column) {
      this.selectedColumn = $column;
    },
    submit($objKey) {
      let $layout = this.columnLayout;
      if ($layout.indexOf($objKey) >= 0) {
        $layout.splice($layout.indexOf($objKey), 1);
      } else {
        $layout.push($objKey);
      }
      this.$emit("layoutChanged", $layout);
    },
    showExpressionDialog() {
      this.expressionDialog = true;
    }
  }
};
</script>